/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the httpStatus is not OK
 * @export
 * @class HttpNotOkError
 * @extends {Error}
 */
export class HttpNotOkError extends Error {
  /**
   * Creates an instance of HttpNotOkError
   * @param {string} message The Error `message`
   * @param {any} errorResponse The error response
   * @memberof HttpNotOkError
   */
  constructor(message, errorResponse) {
    super(message);
    this.name = `HttpNotOkError`;
    this.response = errorResponse;
  }
}

/**
 * Called when the httpStatus is not OK
 * @param {Exclude<HttpStatusXXX, HttpStatus2XX>} status The http status
 * @param {any} errorResponse The error response
 * @returns {never} never
 */
const throwHttpNotOkError = (status, errorResponse) => {
  throw new HttpNotOkError(
    stripIndent(`
    Expected http status to be OK. Got: [${status}] "${errorResponse}".
    `),
    errorResponse,
  );
};

export default throwHttpNotOkError;
